import {
  customScrollMinimal,
  Modal,
  SkeletonLoader,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ${Modal.Styled.ModalContainer} {
    display: flex;
    flex-direction: column;
    width: max(35%, 1216px);
    max-height: calc(100% - 80px);
  }
`;

export const ContentWrapper = styled.div`
  height: 100%;
  overflow-y: scroll;
  ${customScrollMinimal};
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
      },
    },
  ],
})`
  height: 750px;
`;
